import { render, staticRenderFns } from "./SystemConfigView.vue?vue&type=template&id=588c074d&scoped=true&"
import script from "./SystemConfigView.vue?vue&type=script&lang=js&"
export * from "./SystemConfigView.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigView.vue?vue&type=style&index=0&id=588c074d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c074d",
  null
  
)

export default component.exports